import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId: number]: string } = {
  1: '0xcA11bde05977b3631167028862bE2a173976CA11', // Multicall3, Ethereum mainnet
  97: '0xcA11bde05977b3631167028862bE2a173976CA11', // Multicall3, BSC testnet
  523994005626: '0x6e32360563621B5eFe0411e37F0C9fd7752b8b3e', // TODO
  1115: '0x6e32360563621B5eFe0411e37F0C9fd7752b8b3e',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
